import { Button, EmptyState, HStack } from '@astryxdesign/core';

export function NotFoundPage() {
  return (
    <div className="shell section-block">
      <EmptyState
        title="Page not found"
        description="That URL does not exist. It may have been renamed, or the link was wrong."
        actions={
          <HStack gap={1.5}>
            <Button label="Go home" variant="primary" href="/" />
            <Button label="API docs" variant="secondary" href="/docs" />
          </HStack>
        }
      />
    </div>
  );
}
